import { SiteMetadata } from '@/api/fe-api/domain/entities/site-metadata';
import { Tooltip } from '@/components/ui/tooltip';
import { cls } from '@/utils/cls';
import { scrollToId } from '@/utils/dom/scroll-to-id';
import { toTitleCase } from '@/utils/format/title-case';

import { SiteMetadataValue } from './site-metadata-value';

export type SiteMetadataRowProps = {
  row: SiteMetadata.Row;
  documentIndexes: Record<string, number>;
};

export function SiteMetadataRow({
  row,
  documentIndexes,
}: SiteMetadataRowProps) {
  // Add type to value for easier formatting
  if (row.value.type === 'string') {
    if (row.key.includes('type')) {
      row.value.format = 'type';
    } else if (row.key === 'manufacturer') {
      row.value.format = 'type'; // render like types
    } else if (row.key === 'cell_chemistry') {
      row.value.format = 'type'; // render like types
    } else {
      row.value.format = 'default';
    }
  }

  return (
    <div
      className={cls(
        'px-6 py-4 even:bg-stone-100 sm:grid sm:grid-cols-3 sm:gap-4',
      )}
    >
      <dt className="text-sm font-medium leading-6 text-gray-900">
        {keyLabel(row.key)}
      </dt>
      <dd className="mr-4 flex justify-between text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
        <span>
          <SiteMetadataValue value={row.value} />
        </span>
        <span>
          {row.document ? (
            <Tooltip delay content={`Source: '${row.document.name}'`}>
              <div
                className="cursor-pointer text-primary-400 hover:text-primary-500"
                onClick={function () {
                  if (row.document) {
                    scrollToId(`source-${row.document.id}`);
                  }
                }}
              >
                [{documentIndexes[row.document.id] + 1}]
              </div>
            </Tooltip>
          ) : null}
        </span>
      </dd>
    </div>
  );
}

function keyLabel(key: string) {
  // TODO: we could have a dictionnary key -> label

  // Always try to make it human readable as fallback
  return toTitleCase(
    key
      .split('_')
      .join(' ')
      .replace(/\bid\b/gi, 'ID')
      .replace(/\baccure\b/gi, 'ACCURE')
      .replace(/^\w/, (c) => c.toUpperCase()),
  );
}
